import React, { useState } from "react";
import classNames from "classnames";
import { Button } from "semantic-ui-react";
import { ModalBuilder, Form } from "@redriver/cinnamon";
import { getDealerOfficeLogo, editDealerOfficeLogo } from "./actions";
import { TranslatedModal } from "features/../../../shared/components/modals";
import { useTranslation } from "react-i18next";

const EditDealerOfficeLogo = ({ dealerOfficeId, onUpdate }) => {
  const [logoData, setDealerLogo] = useState(null);
  const { t } = useTranslation("supplierOffices", {
    keyPrefix: "supplierLogo",
  });

  const onchangeDealerLogo = (file) => {
    let fileReader = new FileReader();
    fileReader.onload = () => {
      const res = fileReader.result;
      setDealerLogo(res);
    };
    fileReader.readAsDataURL(file);
  };

  return (
    <ModalBuilder
      withForm
      loadAction={getDealerOfficeLogo}
      loadParams={dealerOfficeId}
      submitAction={editDealerOfficeLogo}
      submitParams={{ logoData, dealerOfficeId }}
      onSubmitted={onUpdate}
      renderTrigger={(showModal) => (
        <Button icon="edit" onClick={showModal} className="edit-button" />
      )}
      renderModal={(modalProps, formProps) => (
        <TranslatedModal.Edit
          {...modalProps}
          header={t("header")}
          submitLabel={t("submitLabel")}
        >
          <Form {...formProps}>
            <Form.Group widths="equal">
              <Form.FileUpload
                field="logo"
                label={t("logoImage")}
                fluid
                className={classNames(
                  "file-upload",
                  formProps &&
                    formProps.value &&
                    formProps.value.logo &&
                    "file-selected"
                )}
                uploadText={t("uploadText")}
                fileExtensionTypes={["png", "jpg", "jpeg"]}
                customValidator={(_, __, ___, { value }) => {
                  !!value?.logo && onchangeDealerLogo(value?.logo);
                }}
              />
            </Form.Group>
          </Form>
        </TranslatedModal.Edit>
      )}
    />
  );
};

export default EditDealerOfficeLogo;
